module.exports = __webpack_public_path__ + "img/kg-icon.79552315.png";